import { createStore, withProps } from '@ngneat/elf';
import { SocieteDacListItem } from '@/types';

export interface PaymentJustificationStateProps {
  response: SocieteDacListItem | null;
  dto: SocieteDacListItem | null;
  errors: Record<string, string[]>;
  selectedDocument: {
    justifPaiementId: number | null;
    documentUrl: string | null;
    documentName: string | null;
  };
}

export const paymentJustificationInitialState: PaymentJustificationStateProps = {
  response: null,
  dto: null,
  errors: {},
  selectedDocument: {
    justifPaiementId: null,
    documentUrl: null,
    documentName: null,
  },
};

export const paymentJustificationStateStore = createStore({ name: 'paymentJustification' }, withProps(paymentJustificationInitialState));
